import { Adapter } from '../adapters/Adapter';

export class BannerMessage {
    constructor(
    public id: number,
    public message: string,
    public picture: string,
    public title: string,
    public type: 'info',
    public visibility_mobile_inside: boolean,
    public visibility_mobile_splash: boolean,
    public visibility_web_inside: boolean,
    public visibility_web_welcome: boolean
    ) {

    }
}

export class BannerMessageAdapter implements Adapter<BannerMessage> {
    adapt(rawItem: any): BannerMessage {
        return new BannerMessage(
            rawItem.id,
            rawItem.message,
            rawItem.picture,
            rawItem.title,
            rawItem.type,
            rawItem.visibility_mobile_inside,
            rawItem.visibility_mobile_splash,
            rawItem.visibility_web_inside,
            rawItem.visibility_web_welcome
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/models/BannerMessage.ts